export const PUSH_API_ERROR = 'PUSH_API_ERROR'
export const REMOVE_OLDEST_API_ERROR = 'REMOVE_OLDEST_API_ERROR'
